import {downloadFile} from '@/utils/file-download';

export function useDownloadBuildPdf() {
  const downloadBuildPdf = async ({buildId, formData}) => {
    const esc = encodeURIComponent;
    const queryParams = Object.keys(formData)
      .map((k) => esc(k) + '=' + esc(formData[k]))
      .join('&');

    const requestUrl = `/project-one/sell-sheet/${buildId}/pdf?${queryParams}`;
    return downloadFile(requestUrl, `Project_One_Sell_Sheet_${buildId}.pdf`, 'application/pdf');
  };

  return {
    downloadBuildPdf,
  };
}
